import video from '../../assets/video/bg_video.mp4';
import { Link } from 'react-router-dom';

function Video(){
  return (
    <>
        <div className="home__video full-horizon">
            <div className="home__video-content">
                <div className="video__content-box full-horizon column">
                    <div className="video__content-text">
                        <h1 className="text__headtitle">건강한 삶을 위한 당신의 선택</h1>
                        <h3 className="text__subtitle">관절 건강을 위해 자연에서 온 보조제 <br/> 우리 몸이 균형을 찾게 도와줍니다</h3>                            </div>
                    <div className="video__content-button">
                        <Link to="/products">
                            <button className="video__button">제품 보기</button>
                        </Link>
                    </div>
                </div>
            </div>
            <video muted autoPlay loop>
                <source src={video} type="video/mp4"/>
                <strong>Your browser does not support the video tag.</strong>
            </video>
        </div>
        <div className="home__video-underbox row">
            <div className="underbox__container column">
               <h3>100% 자연산</h3>
               <p>점진적이고 효과적인 도움</p> 
            </div>
            <div className="underbox__container column">
               <h3>과학적 연구를 통한 제품</h3>
               <p>몸이 필요로 하는 최적의 영양 공급</p> 
            </div>
            <div className="underbox__container column">
               <h3>보증된 품질</h3>
               <p>전제품의 품질과 지속된 생산을 보장</p> 
            </div>
        </div>
    </>
  );
};

export default Video;